<template>
  <div
    class="flex gap-2 items-center mt-2 uppercase text-sm text-platform-text-3"
  >
    <p>{{ $t("framingUpsell.poweredBy") }}</p>
    <img
      src="public/icons/frame-the-game-logo.svg"
      alt="Frame the game logo"
      width="32px"
      height="32px"
    />
  </div>
</template>
